import s from "./style.module.scss";

type CtaButtonProps = {
  text: string;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
  reversedStyles?: boolean;
};

export const CtaButton = ({
  text,
  type,
  style,
  onClick,
  className,
  reversedStyles,
}: CtaButtonProps) => (
  <button
    className={`${s.ctaButton} ${className} ${
      reversedStyles ? s.ctaButton__bestValue : ""
    }`}
    type={type}
    style={style}
    onClick={onClick}
    dangerouslySetInnerHTML={{ __html: text }}
  />
);
